import { store } from '../store.js'

export const whatsAppTemplatesMixin = {
    mixins: [],
    props: {
    },
    data: function() {
        return {
            whatsAppTemplates: []
        }
    },
    computed: {
        approvedWhatsAppTemplates: function() {
            return this.whatsAppTemplates.filter(template => template.status === 'approved' && template.contentType !== 'form-invite');
        },
        approvedFormInviteWhatsAppTemplates: function() {
            return this.whatsAppTemplates.filter(template => template.status === 'approved' && template.contentType === 'form-invite');
        },
    },
    methods: {
        fetchWhatsAppTemplates: async function () {
            this.loading = true;
            try {
                const response = await this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/templates', {
                    withCredentials: true
                });
                console.log(response);
                if (response.data) {
                    this.whatsAppTemplates = response.data;
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        isWhatsAppTemplateApproved: function (templateReference) {
            const template = this.whatsAppTemplates.find(t => t.reference === templateReference);
            return template ? template.status === 'approved' : false;
        }
    },
}